import { mapMedicationRowToValues } from '../../../../../common';
import { MEDICATION_FORM_SCHEMA } from './validationSchema';

import type { IMedication } from '../../../../../common';

export function areIntakeMedicationsComplete(rows: ReadonlyArray<IMedication>): boolean {
  return rows.every((row) => MEDICATION_FORM_SCHEMA.isValidSync(mapMedicationRowToValues(row)));
}
